"use client";

import { FeatureHighlight, MainLink } from "@/components/shared/public";
import { Separator } from "@/components/ui/separator";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { threeSixtyLogo } from "../../../../public/images/logos";
import { threeSixtyCam } from "../../../../public/images/three-sixty";

const ServiceDescription = () => {
  const t = useTranslations("threeSixtyTour.serviceDescription");
  const tC = useTranslations("common");

  /* 
    - examples not available yet - replace when available again
    <MainLink
      href={"/beispiele-360-grad-rundgang"}
      title={tC("examples")}
    />
  */

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-10">
        <FeatureHighlight
          src={threeSixtyLogo}
          alt={"360-Grad-Rundgang Icon der Grundriss Schmiede"}
          title={t("title")}
          text={t("text")}
        />

        <div className="flex flex-col items-center gap-10 md:flex-row md:gap-20">
          <div className="flex flex-col gap-10">
            <Separator />
            <p className="text-ring">{t("text2")}</p>
            <p className="text-ring">{t("text3")}</p>
            <Separator />
            <div className="s:flex-row s:items-center flex flex-col gap-2">
              <MainLink
                href={"/schritt-fuer-schritt-anleitung-360-grad-rundgang"}
                title={t("linkTitle")}
              />
              
            </div>
          </div>
          <Image
            src={threeSixtyCam}
            alt={"360-Grad-Kamera"}
            className="h-[490px] w-auto"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceDescription;
